export const communityData = [
  {
    img: "../../community/Lokesh.jpg",
    name: "Lokesh",
  },

  {
    img: "../../community/Chaman.jpg",
    name: "Chaman",
  },
  {
    img: "../../community/Himanshu.jpg",
    name: "Himanshu",
  },
  {
    img: "../../community/Gaurav.jpg",
    name: "Gaurav",
  },
  {
    img: "../../community/Vaibhav.jpg",
    name: "Vaibhav",
  },
];
